import { h } from '@stencil/core';
export const ChipsBlock = ({ data, selected, title }) => {
  return (h("div", { class: 'cc-header__chips' }, h("div", { class: 'cc-header__chips-title' }, title), h("pes-chips-list", { data: data, selected: selected })));
};
